import type { AttributesCodeBlock } from './attributes'
import { validate } from '@/helpers/validate'
import { guideCodeBlockHtml } from './component'
import type { ScalarGuideElement } from '@/types'
import { attributesCodeBlockSchema } from './attributes'
export { ScalarCodeBlockVue } from './component'

export const scalarCodeBlock: ScalarGuideElement<
  AttributesCodeBlock,
  'scalar-code'
> = {
  name: 'scalar-code',
  tagName: 'scalar-code',
  tiptapName: 'custom_code_block',
  attributeTransform: (_, attrs) => {
    return validate(attributesCodeBlockSchema, {
      ...attrs,
      lang: attrs.lang || 'plaintext',
    })
  },
  render: async (props) => {
    const transformed = scalarCodeBlock.attributeTransform('', props)
    return transformed ? guideCodeBlockHtml(transformed) : ''
  },
}
